export default __webpack_public_path__ + "static/media/discussion-right.a45b9b12.svg";